export default "__VITE_ASSET__BFzBOFVP__"